module.exports = __webpack_public_path__ + "img/towel.16db4bee.png";